import { render, staticRenderFns } from "./ItemRenderer.vue?vue&type=template&id=7dd310ff&scoped=true&"
import script from "./ItemRenderer.vue?vue&type=script&lang=js&"
export * from "./ItemRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ItemRenderer.vue?vue&type=style&index=0&id=7dd310ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd310ff",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd310ff')) {
      api.createRecord('7dd310ff', component.options)
    } else {
      api.reload('7dd310ff', component.options)
    }
    module.hot.accept("./ItemRenderer.vue?vue&type=template&id=7dd310ff&scoped=true&", function () {
      api.rerender('7dd310ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/ItemRenderer.vue"
export default component.exports